document.addEventListener('DOMContentLoaded', () => {
  const sortBySelects = document.querySelectorAll('select[name="sort_by"]'),
    mobileFiltersToggle = document.querySelectorAll('*:is(.filter-results-close, .filter-results-toggle)'),
    filterCheckboxes = document.querySelectorAll('.filters-form input[type="checkbox"]:not([name="compare-products-toggle"],.filter-list-toggle-checkbox,.filter-information-toggle-checkbox)'),
    filterForm = document.querySelector('.filters-form'),
    priceInputs = filterForm ? filterForm.querySelectorAll('input[type="number"]') : [];

  // Debounce function for API calls
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Get the base URL for the collection or search
  function getBaseUrl() {
    const url = new URL(window.location.href);
    const pathname = url.pathname;

    // Check if it's a search page
    if (pathname.includes('/search')) {
      return '/search';
    }

    // Otherwise it's a collection
    return pathname;
  }

  // Build filter parameters from form
  function buildFilterParams() {
    if (!filterForm) return '';

    const params = new URLSearchParams();

    // Add search query if it exists
    const searchInput = filterForm.querySelector('input[name="q"]');
    if (searchInput && searchInput.value) {
      params.append('q', searchInput.value);
    }

    // Add type for search
    const typeInput = filterForm.querySelector('input[name="type"]');
    if (typeInput && typeInput.value) {
      params.append('type', typeInput.value);
    }

    // Add all checked filter checkboxes
    filterCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        params.append(checkbox.name, checkbox.value);
      }
    });

    // Add price range inputs
    priceInputs.forEach(input => {
      if (input.value && input.value.trim() !== '') {
        params.append(input.name, input.value);
      }
    });

    // Add sort_by if it exists
    const sortBy = filterForm.querySelector('[name="sort_by"]');
    if (sortBy && sortBy.value) {
      params.append('sort_by', sortBy.value);
    }

    return params.toString();
  }

  // Fetch updated product count
  async function fetchProductCount() {
    if (!filterForm) return;

    const baseUrl = getBaseUrl();
    const filterParams = buildFilterParams();
    const url = `${baseUrl}${filterParams ? '?' + filterParams : ''}`;

    try {
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Try to find product count from the filter block in the response
      const responseFilterForm = doc.querySelector('.filters-form');
      if (responseFilterForm) {
        // Look for the product count label
        const countLabel = responseFilterForm.querySelector('.filter-products-count-label');
        if (countLabel) {
          // Extract count from text like "Showing 12 Options" or "12 Options"
          const countMatch = countLabel.textContent.match(/(\d+)/);
          if (countMatch) {
            const newCount = parseInt(countMatch[1], 10);
            updateApplyButtons(newCount);
            return;
          }
        }

        // Alternative: Look for apply buttons in the response to get the count
        const responseApplyButtons = responseFilterForm.querySelectorAll('.filter-group-display__submit button, .filter-group-all__submit button');
        if (responseApplyButtons.length > 0) {
          const firstButton = responseApplyButtons[0];
          const countSpan = firstButton.querySelector('.active-product-count');
          if (countSpan) {
            const newCount = parseInt(countSpan.textContent.trim(), 10);
            if (!isNaN(newCount)) {
              updateApplyButtons(newCount);
              return;
            }
          }
        }
      }

      // Fallback: Try to get count from product grid
      const productGrid = doc.querySelector('.product-grid, [class*="product-grid"]');
      if (productGrid) {
        const productCards = productGrid.querySelectorAll('[data-product-id], .product-card, [class*="product-card"]');
        if (productCards.length > 0) {
          updateApplyButtons(productCards.length);
        }
      }
    } catch (error) {
      // Silently fail - don't update count if there's an error
      console.error('Error fetching product count:', error);
    }
  }

  // Update all apply buttons with new count
  function updateApplyButtons(count) {
    if (!filterForm || isNaN(count)) return;

    const applyButtons = filterForm.querySelectorAll('.filter-group-display__submit button, .filter-group-all__submit button');

    applyButtons.forEach(button => {
      const span = button.querySelector('.active-product-count');
      if (span) {
        span.textContent = count;
      } else {
        // If span doesn't exist, try to preserve button structure
        // Replace any number in the button text with the new count
        const currentText = button.textContent;
        const updatedText = currentText.replace(/\d+/, count);
        if (updatedText !== currentText) {
          button.textContent = updatedText;
        }
      }
    });
  }

  // Debounced version of fetchProductCount
  const debouncedFetchCount = debounce(fetchProductCount, 300);

  // Listen for filter changes
  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', (e) => {
      if (window.innerWidth > 1024) {
        // On desktop, form submits immediately (count will be correct after page reload)
        const form = checkbox.closest('form');
        form.submit();
      } else {
        // On mobile, update count dynamically without submitting
        debouncedFetchCount();
      }
    });
  });

  // Listen for price input changes (mobile only)
  priceInputs.forEach(input => {
    input.addEventListener('input', () => {
      // Only update count on mobile - desktop will submit automatically
      if (window.innerWidth <= 1024) {
        debouncedFetchCount();
      }
    });
  });

  sortBySelects.forEach(sortBySelect => {
    sortBySelect.addEventListener('change', (e) => {
      const form = sortBySelect.closest('form');
      sortBySelects.forEach(sortBySelect => sortBySelect.value = e.target.value);
      form.submit();
    });
  });

  mobileFiltersToggle.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      const filterForm = e.target.closest('.filters-form');
      filterForm.dataset.mobileFilters = filterForm.dataset.mobileFilters === 'true' ? 'false' : 'true';
    });
  });

  const sortSelects = document.querySelectorAll('[data-sort]');
  sortSelects.forEach(select => {
    select.addEventListener('change', e => {
      sortSelects.forEach(s => (s.value = e.target.value));
      document.querySelector('[name="sort_by"]').value = e.target.value;
      document.querySelector('.filters-form').submit();
    });
  });
});